export const ROUTES = {
    ROOT: '/',
    PROFILE: '/profile',
    MY_PROFILE: '/my-profile',
    SEARCH: '/search',

    // Collection Routes - Updated to match CollectionType enum
    CREATOR_OWN_COLLECTION: '/creator-own-collection', // CREATOR_OWN - creator viewing own collection
    COLLECTOR_OWN_COLLECTION: '/collector-own-collection', // COLLECTOR_OWN - user viewing own collection
    EDIT_CREATOR_OWN_COLLECTION: '/edit-creator-own-collection/:id', // Edit a creator's own collection details
    EDIT_COLLECTOR_OWN_COLLECTION: '/edit-collector-own-collection/:id', // Edit a collector's own collection details
    CREATOR_OTHER_COLLECTION_FREE: '/creator-other-collection-free', // CREATOR_OTHER - view a creator's collection
    CREATOR_OTHER_COLLECTION_PAID_LOCKED:
        '/creator-other-collection-paid-locked', // CREATOR_OTHER - paid collection, locked
    CREATOR_OTHER_COLLECTION_PAID_SUBSCRIBED:
        '/creator-other-collection-paid-subscribed', // CREATOR_OTHER - paid collection, subscribed

    // Product Routes
    PRODUCTS: '/products',
    DETAIL_PRODUCTS: '/products/:id/detail',
    OWN_PRODUCTS: '/own-products',
    DETAIL_OWN_PRODUCTS: '/own-products/:id/detail',

    // Look Routes
    LOOKS: '/looks',
    OWN_LOOKS: '/own-looks',
    EDIT_OWN_LOOKS: '/own-looks/:lookId/edit',
    CREATE_OWN_LOOKS: '/own-looks/create',

    // User Related Routes
    FOLLOWS: '/follows',
    LOGOUT: '/logout',

    // Settings Routes
    SETTINGS: '/settings',
    ACCOUNT: '/settings/account',
    CHANGE_PASSWORD: '/settings/account/change-password',
    MANAGE_SUBSCRIBTIONS: '/settings/manage-subscribtions',
    ABOUT: '/settings/about',
    TERMS_PRIVACY: '/settings/terms-privacy',
    FEEDBACK: '/settings/feedback',
    ARCHIVE: '/settings/archive',
    CONTACT_SUPPORT: '/settings/contact-support',

    // Legal Documents
    TERMS_AND_CONDITIONS: '/terms-and-conditions',
    PRIVACY_POLICY: '/privacy-policy',
    TERMS_OF_USE: '/terms-of-use',

    // Creator Settings
    YOUR_SUBSCRIPTION_PRICE: '/settings/your-subscription-price',
    WALLET: '/settings/wallet',
    DASHBOARD: '/settings/dashboard',

    // Misc
    SITEMAP: '/sitemap',

    // Admin Routes
    ADMIN: '/admin',
    ADMIN_DASHBOARD: '/admin/dashboard',
    ADMIN_PENDING_USERS: '/admin/pending-users',

    // Onboarding & Auth Routes
    ONBOARDING: '/onboarding',
    REGISTER: '/register', // Initial registration (email/pass/name or Google trigger)
    REGISTER_USERNAME: '/register/username',
    REGISTER_ACCOUNT_TYPE: '/register/account-type', // New route for account type selection
    REGISTER_INSTAGRAM: '/register/instagram', // New route for creator instagram input
    LOGIN: '/login',
    FORGOT_PASSWORD: '/forgot-password',
    FORGOT_PASSWORD_SENT: '/forgot-password/sent',
}
